import { z } from "zod";

export const LoginFormSchema = z.object({
  email: z.string().email({ message: "Invalid email address" }),
  password: z
    .string()
    .min(6, { message: "Password must be at least 6 characters long" })
    .regex(/[A-Z]/, {
      message: "Password must contain at least one uppercase letter",
    })
    .regex(/[0-9]/, { message: "Password must contain at least one number" }),
});

export const CreateRouteSchema = z.object({
  appleStoreId: z.string().optional(),
  playStoreId: z.string().optional(),
  timeDuration: z
    .string()
    .regex(/^((\d{1,2}h(\s?\d{1,2}min)?)|(\d{1,2}min))$/, {
      message: "Invalid duration format",
    })
    .optional(),
  isFree: z.boolean(),
  previewImagePath: z.string().optional(),
  sponsorId: z.coerce.number().int().gt(0, { message: "Select sponsor" }),
  cityId: z.coerce.number().int().gt(0, { message: "Select city" }),
  languageCode: z.string(),
  name: z.string(),
});

export const AddLanguageFormSchema = z.object({
  routeName: z.string().min(1, { message: "Route name is required" }).max(200, {
    message: "Route name must be at most 200 characters long",
  }),
  description: z.string().min(1, { message: "Description is required" }),
});
